var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInformationGrid2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 551.772,
    height: 326.899,
    viewBox: "0 0 551.772 326.899",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 430,
    width: 551.772,
    height: 326.899,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_183993",
    "data-name": "\\uADF8\\uB8F9 183993",
    transform: "translate(0.317 -2113.254)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uC2A4\\uD06C\\uB864_\\uADF8\\uB8F9_36",
    "data-name": "\\uC2A4\\uD06C\\uB864 \\uADF8\\uB8F9 36",
    transform: "translate(-430.317 2113.254)",
    clipPath: "url(#clip-path)",
    style: {
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182813",
    "data-name": "\\uADF8\\uB8F9 182813",
    transform: "translate(-86.331 -145.95)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182812",
    "data-name": "\\uADF8\\uB8F9 182812"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182761",
    "data-name": "\\uADF8\\uB8F9 182761"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182760",
    "data-name": "\\uADF8\\uB8F9 182760"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_154095",
    "data-name": "\\uC0AC\\uAC01\\uD615 154095",
    width: 621.025,
    height: 1.2,
    transform: "translate(125.176 480.856) rotate(-28.251)",
    fill: "#8b75f3"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182763",
    "data-name": "\\uADF8\\uB8F9 182763"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182762",
    "data-name": "\\uADF8\\uB8F9 182762"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_154096",
    "data-name": "\\uC0AC\\uAC01\\uD615 154096",
    width: 621.026,
    height: 1.201,
    transform: "translate(167.765 505.7) rotate(-28.293)",
    fill: "#8b75f3"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182765",
    "data-name": "\\uADF8\\uB8F9 182765"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182764",
    "data-name": "\\uADF8\\uB8F9 182764"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_154097",
    "data-name": "\\uC0AC\\uAC01\\uD615 154097",
    width: 407.015,
    height: 1.2,
    transform: "translate(138.141 378.797) rotate(-28.272)",
    fill: "#8b75f3"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182767",
    "data-name": "\\uADF8\\uB8F9 182767"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182766",
    "data-name": "\\uADF8\\uB8F9 182766"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_154098",
    "data-name": "\\uC0AC\\uAC01\\uD615 154098",
    width: 621.025,
    height: 1.201,
    transform: "translate(86.331 454.026) rotate(-28.251)",
    fill: "#8b75f3"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182769",
    "data-name": "\\uADF8\\uB8F9 182769"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182768",
    "data-name": "\\uADF8\\uB8F9 182768"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_154099",
    "data-name": "\\uC0AC\\uAC01\\uD615 154099",
    width: 621.025,
    height: 1.2,
    transform: "translate(210.152 530.164) rotate(-28.256)",
    fill: "#8b75f3"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182771",
    "data-name": "\\uADF8\\uB8F9 182771"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182770",
    "data-name": "\\uADF8\\uB8F9 182770"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_154100",
    "data-name": "\\uC0AC\\uAC01\\uD615 154100",
    width: 621.025,
    height: 1.2,
    transform: "translate(252.584 554.714) rotate(-28.236)",
    fill: "#8b75f3"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182773",
    "data-name": "\\uADF8\\uB8F9 182773"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182772",
    "data-name": "\\uADF8\\uB8F9 182772"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_154101",
    "data-name": "\\uC0AC\\uAC01\\uD615 154101",
    width: 621.025,
    height: 1.2,
    transform: "translate(295.157 579.529) rotate(-28.272)",
    fill: "#8b75f3"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182775",
    "data-name": "\\uADF8\\uB8F9 182775"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182774",
    "data-name": "\\uADF8\\uB8F9 182774"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_154102",
    "data-name": "\\uC0AC\\uAC01\\uD615 154102",
    width: 621.025,
    height: 1.201,
    transform: "matrix(0.88, -0.475, 0.475, 0.88, 337.86, 604.585)",
    fill: "#8b75f3"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182777",
    "data-name": "\\uADF8\\uB8F9 182777"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182776",
    "data-name": "\\uADF8\\uB8F9 182776"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_154103",
    "data-name": "\\uC0AC\\uAC01\\uD615 154103",
    width: 621.026,
    height: 1.2,
    transform: "matrix(0.881, -0.474, 0.474, 0.881, 380.141, 628.852)",
    fill: "#8b75f3"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182779",
    "data-name": "\\uADF8\\uB8F9 182779"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182778",
    "data-name": "\\uADF8\\uB8F9 182778"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_154104",
    "data-name": "\\uC0AC\\uAC01\\uD615 154104",
    width: 621.025,
    height: 1.2,
    transform: "translate(422.453 653.178) rotate(-28.213)",
    fill: "#8b75f3"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182781",
    "data-name": "\\uADF8\\uB8F9 182781"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182780",
    "data-name": "\\uADF8\\uB8F9 182780"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_154105",
    "data-name": "\\uC0AC\\uAC01\\uD615 154105",
    width: 621.025,
    height: 1.201,
    transform: "translate(465.034 678.007) rotate(-28.251)",
    fill: "#8b75f3"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182783",
    "data-name": "\\uADF8\\uB8F9 182783"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182782",
    "data-name": "\\uADF8\\uB8F9 182782"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_154106",
    "data-name": "\\uC0AC\\uAC01\\uD615 154106",
    width: 621.025,
    height: 1.201,
    transform: "translate(507.624 702.852) rotate(-28.293)",
    fill: "#8b75f3"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182785",
    "data-name": "\\uADF8\\uB8F9 182785"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182784",
    "data-name": "\\uADF8\\uB8F9 182784"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_154107",
    "data-name": "\\uC0AC\\uAC01\\uD615 154107",
    width: 554.353,
    height: 1.2,
    transform: "translate(579.512 711.793) rotate(-28.316)",
    fill: "#8b75f3"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182787",
    "data-name": "\\uADF8\\uB8F9 182787"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182786",
    "data-name": "\\uADF8\\uB8F9 182786"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_154108",
    "data-name": "\\uC0AC\\uAC01\\uD615 154108",
    width: 1.2,
    height: 621.025,
    transform: "translate(518.053 173.836) rotate(-61.733)",
    fill: "#8b75f3"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182789",
    "data-name": "\\uADF8\\uB8F9 182789"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182788",
    "data-name": "\\uADF8\\uB8F9 182788"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_154109",
    "data-name": "\\uC0AC\\uAC01\\uD615 154109",
    width: 1.2,
    height: 621.025,
    transform: "matrix(0.474, -0.881, 0.881, 0.474, 475.073, 197.625)",
    fill: "#8b75f3"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182791",
    "data-name": "\\uADF8\\uB8F9 182791"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182790",
    "data-name": "\\uADF8\\uB8F9 182790"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_154110",
    "data-name": "\\uC0AC\\uAC01\\uD615 154110",
    width: 1.2,
    height: 569.642,
    transform: "translate(556.897 147.007) rotate(-61.733)",
    fill: "#8b75f3"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182793",
    "data-name": "\\uADF8\\uB8F9 182793"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182792",
    "data-name": "\\uADF8\\uB8F9 182792"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_154111",
    "data-name": "\\uC0AC\\uAC01\\uD615 154111",
    width: 1.2,
    height: 621.026,
    transform: "translate(433.088 223.124) rotate(-61.732)",
    fill: "#8b75f3"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182795",
    "data-name": "\\uADF8\\uB8F9 182795"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182794",
    "data-name": "\\uADF8\\uB8F9 182794"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_154112",
    "data-name": "\\uC0AC\\uAC01\\uD615 154112",
    width: 1.2,
    height: 621.025,
    transform: "translate(390.605 247.768) rotate(-61.733)",
    fill: "#8b75f3"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182797",
    "data-name": "\\uADF8\\uB8F9 182797"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182796",
    "data-name": "\\uADF8\\uB8F9 182796"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_154113",
    "data-name": "\\uC0AC\\uAC01\\uD615 154113",
    width: 1.2,
    height: 637.591,
    transform: "translate(335.103 261.658) rotate(-61.435)",
    fill: "#8b75f3"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182799",
    "data-name": "\\uADF8\\uB8F9 182799"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182798",
    "data-name": "\\uADF8\\uB8F9 182798"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_154114",
    "data-name": "\\uC0AC\\uAC01\\uD615 154114",
    width: 1.2,
    height: 637.591,
    transform: "matrix(0.478, -0.878, 0.878, 0.478, 292.621, 286.302)",
    fill: "#8b75f3"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182801",
    "data-name": "\\uADF8\\uB8F9 182801"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182800",
    "data-name": "\\uADF8\\uB8F9 182800"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_154115",
    "data-name": "\\uC0AC\\uAC01\\uD615 154115",
    width: 1.2,
    height: 637.59,
    transform: "translate(250.139 310.946) rotate(-61.435)",
    fill: "#8b75f3"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182803",
    "data-name": "\\uADF8\\uB8F9 182803"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182802",
    "data-name": "\\uADF8\\uB8F9 182802"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_154116",
    "data-name": "\\uC0AC\\uAC01\\uD615 154116",
    width: 1.2,
    height: 637.591,
    transform: "translate(207.656 335.59) rotate(-61.435)",
    fill: "#8b75f3"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182805",
    "data-name": "\\uADF8\\uB8F9 182805"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182804",
    "data-name": "\\uADF8\\uB8F9 182804"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_154117",
    "data-name": "\\uC0AC\\uAC01\\uD615 154117",
    width: 1.2,
    height: 637.592,
    transform: "translate(165.174 360.234) rotate(-61.435)",
    fill: "#8b75f3"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182807",
    "data-name": "\\uADF8\\uB8F9 182807"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182806",
    "data-name": "\\uADF8\\uB8F9 182806"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_154118",
    "data-name": "\\uC0AC\\uAC01\\uD615 154118",
    width: 1.2,
    height: 621.026,
    transform: "translate(135.712 395.632) rotate(-61.733)",
    fill: "#8b75f3"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182809",
    "data-name": "\\uADF8\\uB8F9 182809"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182808",
    "data-name": "\\uADF8\\uB8F9 182808"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_154119",
    "data-name": "\\uC0AC\\uAC01\\uD615 154119",
    width: 1.201,
    height: 554.353,
    transform: "matrix(0.474, -0.881, 0.881, 0.474, 122.59, 436.064)",
    fill: "#8b75f3"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182811",
    "data-name": "\\uADF8\\uB8F9 182811"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182810",
    "data-name": "\\uADF8\\uB8F9 182810"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_154120",
    "data-name": "\\uC0AC\\uAC01\\uD615 154120",
    width: 1.201,
    height: 444.918,
    transform: "matrix(0.474, -0.881, 0.881, 0.474, 128.3, 486.621)",
    fill: "#8b75f3"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformationGrid2);
export default __webpack_public_path__ + "static/media/information_grid2.b27ebee81a328737d73b768a5aa75c60.svg";
export { ForwardRef as ReactComponent };